import { createAction } from 'redux-actions';
import Types from './types';

export const newEnvironmentRequest = createAction(
  Types.NEW_ENVIRONMENT_REQUEST
);
export const newEnvironmentFulfilled = createAction(
  Types.NEW_ENVIRONMENT_FULFILLED
);
export const newEnvironmentRejected = createAction(
  Types.NEW_ENVIRONMENT_REJECTED
);

export const toggleBlockMultipleInstancesRequest = createAction(
  Types.TOGGLE_BLOCK_MULTIPLE_INSTANCES_REQUEST
);
export const toggleBlockMultipleInstancesFulfilled = createAction(
  Types.TOGGLE_BLOCK_MULTIPLE_INSTANCES_FULFILLED
);
export const toggleBlockMultipleInstancesRejected = createAction(
  Types.TOGGLE_BLOCK_MULTIPLE_INSTANCES_REJECTED
);

export const toggleBlockInstancesRequest = createAction(
  Types.TOGGLE_BLOCK_INSTANCES_REQUEST
);
export const toggleBlockInstancesFulfilled = createAction(
  Types.TOGGLE_BLOCK_INSTANCES_FULFILLED
);
export const toggleBlockInstancesRejected = createAction(
  Types.TOGGLE_BLOCK_INSTANCES_REJECTED
);

export const terminateMultipleInstancesRequest = createAction(
  Types.TERMINATE_MULTIPLE_INSTANCE_REQUEST
);
export const terminateMultipleInstancesFulfilled = createAction(
  Types.TERMINATE_MULTIPLE_INSTANCE_FULFILLED
);
export const terminateMultipleInstancesRejected = createAction(
  Types.TERMINATE_MULTIPLE_INSTANCE_REJECTED
);

export const removeMultipleModelsRequest = createAction(
  Types.REMOVE_MULTIPLE_MODELS_REQUEST
);
export const removeMultipleModelsFulfilled = createAction(
  Types.REMOVE_MULTIPLE_MODELS_FULFILLED
);
export const removeMultipleModelsRejected = createAction(
  Types.REMOVE_MULTIPLE_MODELS_REJECTED
);

export const getAlarmsInstanceRequest = createAction(
  Types.GET_ALARMS_INSTANCE_REQUEST
);
export const getAlarmsInstanceFulfilled = createAction(
  Types.GET_ALARMS_INSTANCE_FULFILLED
);
export const getAlarmsInstanceRejected = createAction(
  Types.GET_ALARMS_INSTANCE_REJECTED
);

export const editMaintenanceEnvironmentsRequest = createAction(
  Types.EDIT_MAINTENANCE_ENVIRONMENTS_REQUEST
);
export const editMaintenanceEnvironmentsFulfilled = createAction(
  Types.EDIT_MAINTENANCE_ENVIRONMENTS_FULFILLED
);
export const editMaintenanceEnvironmentsRejected = createAction(
  Types.EDIT_MAINTENANCE_ENVIRONMENTS_REJECTED
);

export const duplicateModelRequest = createAction(
  Types.DUPLICATE_MODEL_REQUEST
);
export const duplicateModelFulfilled = createAction(
  Types.DUPLICATE_MODEL_FULFILLED
);
export const duplicateModelRejected = createAction(
  Types.DUPLICATE_MODEL_REJECTED
);

export const getAllImagesLogsRequest = createAction(
  Types.GET_ALL_IMAGENS_LOGS_REQUEST
);
export const getAllImagesLogsFulfilled = createAction(
  Types.GET_ALL_IMAGENS_LOGS_FULFILLED
);
export const getAllImagesLogsRejected = createAction(
  Types.GET_ALL_IMAGENS_LOGS_REJECTED
);

export const publishNewImageRequest = createAction(
  Types.PUBLISH_NEW_IMAGE_REQUEST
);
export const publishNewImageFulfilled = createAction(
  Types.PUBLISH_NEW_IMAGE_FULFILLED
);
export const publishNewImageRejected = createAction(
  Types.PUBLISH_NEW_IMAGE_REJECTED
);

export const removeEnvironmentRequest = createAction(
  Types.REMOVE_ENVIRONMENT_REQUEST
);
export const removeEnvironmentFulfilled = createAction(
  Types.REMOVE_ENVIRONMENT_FULFILLED
);
export const removeEnvironmentRejected = createAction(
  Types.REMOVE_ENVIRONMENT_REJECTED
);

export const newStopTimeServerPreparationRequest = createAction(
  Types.NEW_STOP_TIME_SERVER_PREPARATION_REQUEST
);
export const newStopTimeServerPreparationFulfilled = createAction(
  Types.NEW_STOP_TIME_SERVER_PREPARATION_FULFILLED
);
export const newStopTimeServerPreparationRejected = createAction(
  Types.NEW_STOP_TIME_SERVER_PREPARATION_REJECTED
);

export const startServerRequest = createAction(Types.START_SERVER_REQUEST);
export const startServerFulfilled = createAction(Types.START_SERVER_FULFILLED);
export const startServerRejected = createAction(Types.START_SERVER_REJECTED);

export const stopServerRequest = createAction(Types.STOP_SERVER_REQUEST);
export const stopServerFulfilled = createAction(Types.STOP_SERVER_FULFILLED);
export const stopServerRejected = createAction(Types.STOP_SERVER_REJECTED);

export const restartServerRequest = createAction(Types.RESTART_SERVER_REQUEST);
export const restartServerFulfilled = createAction(
  Types.RESTART_SERVER_FULFILLED
);
export const restartServerRejected = createAction(
  Types.RESTART_SERVER_REJECTED
);

export const getMaintenanceRequest = createAction(
  Types.GET_MAINTENANCE_REQUEST
);
export const getMaintenanceFulfilled = createAction(
  Types.GET_MAINTENANCE_FULFILLED
);
export const getMaintenanceRejected = createAction(
  Types.GET_MAINTENANCE_REJECTED
);

export const getUrlsEnvironmentsDashboardRequest = createAction(
  Types.GET_HRLS_ENVIRONMENT_REQUEST
);
export const getUrlsEnvironmentsDashboardFulfilled = createAction(
  Types.GET_HRLS_ENVIRONMENT_FULFILLED
);
export const getUrlsEnvironmentsDashboardRejected = createAction(
  Types.GET_HRLS_ENVIRONMENT_REJECTED
);

export const getInstanceChartDashboardRequest = createAction(
  Types.GET_INSTANCE_CHART_REQUEST
);
export const getInstanceChartDashboardFulfilled = createAction(
  Types.GET_INSTANCE_CHART_FULFILLED
);
export const getInstanceChartDashboardRejected = createAction(
  Types.GET_INSTANCE_CHART_REJECTED
);

export const getSessionsChartDashboardRequest = createAction(
  Types.GET_SESSIONS_CHART_REQUEST
);
export const getSessionsChartDashboardFulfilled = createAction(
  Types.GET_SESSIONS_CHART_FULFILLED
);
export const getSessionsChartDashboardRejected = createAction(
  Types.GET_SESSIONS_CHART_REJECTED
);

export const editEnvironmentsRequest = createAction(
  Types.EDIT_ENVIRONMENT_REQUEST
);
export const editEnvironmentsFulfilled = createAction(
  Types.EDIT_ENVIRONMENT_FULFILLED
);
export const editEnvironmentsRejected = createAction(
  Types.EDIT_ENVIRONMENT_REJECTED
);

export const getEnvironmentBehaviorRequest = createAction(
  Types.GET_ENVIRONMENT_BEHAVIOR_REQUEST
);
export const getEnvironmentBehaviorFulfilled = createAction(
  Types.GET_ENVIRONMENT_BEHAVIOR_FULFILLED
);
export const getEnvironmentBehaviorRejected = createAction(
  Types.GET_ENVIRONMENT_BEHAVIOR_REJECTED
);

export const editEnvironmentBehaviorRequest = createAction(
  Types.EDIT_ENVIRONMENT_BEHAVIOR_REQUEST
);
export const editEnvironmentBehaviorFulfilled = createAction(
  Types.EDIT_ENVIRONMENT_BEHAVIOR_FULFILLED
);
export const editEnvironmentBehaviorRejected = createAction(
  Types.EDIT_ENVIRONMENT_BEHAVIOR_REJECTED
);

export const unlinkInstanceRequest = createAction(
  Types.UNLINK_INSTANCE_REQUEST
);
export const unlinkInstanceFulfilled = createAction(
  Types.UNLINK_INSTANCE_FULFILLED
);
export const unlinkInstanceRejected = createAction(
  Types.UNLINK_INSTANCE_REJECTED
);

export const activateInstanceRequest = createAction(
  Types.ACTIVATE_INSTANCE_REQUEST
);
export const activateInstanceFulfilled = createAction(
  Types.ACTIVATE_INSTANCE_FULFILLED
);
export const activateInstanceRejected = createAction(
  Types.ACTIVATE_INSTANCE_REJECTED
);

export const registerNewInstanceRequest = createAction(
  Types.REGISTER_NEW_INSTANCE_REQUEST
);
export const registerNewInstanceFulfilled = createAction(
  Types.REGISTER_NEW_INSTANCE_FULFILLED
);
export const registerNewInstanceRejected = createAction(
  Types.REGISTER_NEW_INSTANCE_REJECTED
);

export const removeSessionsInstanceRequest = createAction(
  Types.REMOVE_SESSIONS_INSTANCE_REQUEST
);
export const removeSessionsInstanceFulfilled = createAction(
  Types.REMOVE_SESSIONS_INSTANCE_FULFILLED
);
export const removeSessionsInstanceRejected = createAction(
  Types.REMOVE_SESSIONS_INSTANCE_REJECTED
);

export const getAllSessionsInInstanceRequest = createAction(
  Types.GET_ALL_SESSIONS_IN_INSTANCE_REQUEST
);
export const getAllSessionsInInstanceFulfilled = createAction(
  Types.GET_ALL_SESSIONS_IN_INSTANCE_FULFILLED
);
export const getAllSessionsInInstanceRejected = createAction(
  Types.GET_ALL_SESSIONS_IN_INSTANCE_REJECTED
);

export const removeInstanceRequest = createAction(
  Types.REMOVE_INSTANCE_REQUEST
);
export const removeInstanceFulfilled = createAction(
  Types.REMOVE_INSTANCE_FULFILLED
);
export const removeInstanceRejected = createAction(
  Types.REMOVE_INSTANCE_REJECTED
);

export const terminateInstanceRequest = createAction(
  Types.TERMINATE_INSTANCE_REQUEST
);
export const terminateInstanceFulfilled = createAction(
  Types.TERMINATE_INSTANCE_FULFILLED
);
export const terminateInstanceRejected = createAction(
  Types.TERMINATE_INSTANCE_REJECTED
);

export const rebootInstanceRequest = createAction(
  Types.REBOOT_INSTANCE_REQUEST
);
export const rebootInstanceFulfilled = createAction(
  Types.REBOOT_INSTANCE_FULFILLED
);
export const rebootInstanceRejected = createAction(
  Types.REBOOT_INSTANCE_REJECTED
);

export const editSecurityRequest = createAction(Types.EDIT_SECURITY_REQUEST);
export const editSecurityFulfilled = createAction(
  Types.EDIT_SECURITY_FULFILLED
);
export const editSecurityRejected = createAction(Types.EDIT_SECURITY_REJECTED);

export const getAllEnvironmentsRequest = createAction(
  Types.GET_ALL_ENVIRONMENTS_REQUEST
);
export const getAllEnvironmentsFulfilled = createAction(
  Types.GET_ALL_ENVIRONMENTS_FULFILLED
);
export const getAllEnvironmentsRejected = createAction(
  Types.GET_ALL_ENVIRONMENTS_REJECTED
);

export const getAllEnvironmentsOperatorRequest = createAction(
  Types.GET_ALL_ENVIRONMENTS_OPERATOR_REQUEST
);
export const getAllEnvironmentsOperatorFulfilled = createAction(
  Types.GET_ALL_ENVIRONMENTS_OPERATOR_FULFILLED
);
export const getAllEnvironmentsOperatorRejected = createAction(
  Types.GET_ALL_ENVIRONMENTS_OPERATOR_REJECTED
);

export const getEnvironmentRequest = createAction(
  Types.GET_ENVIRONMENT_REQUEST
);
export const getEnvironmentFulfilled = createAction(
  Types.GET_ENVIRONMENT_FULFILLED
);
export const getEnvironmentRejected = createAction(
  Types.GET_ENVIRONMENT_REJECTED
);
export const getSecurityStateRequest = createAction(
  Types.GET_SECURITY_STATE_REQUEST
);
export const getSecurityStateFulfilled = createAction(
  Types.GET_SECURITY_STATE_FULFILLED
);
export const getSecurityStateRejected = createAction(
  Types.GET_SECURITY_STATE_REJECTED
);

export const getAllInstancesRequest = createAction(
  Types.GET_ALL_INSTANCES_REQUEST
);
export const getAllInstancesFulfilled = createAction(
  Types.GET_ALL_INSTANCES_FULFILLED
);
export const getAllInstancesRejected = createAction(
  Types.GET_ALL_INSTANCES_REJECTED
);

export const getPreparationServerRequest = createAction(
  Types.GET_PREPARATION_SERVER_REQUEST
);
export const getPreparationServerFulfilled = createAction(
  Types.GET_PREPARATION_SERVER_FULFILLED
);
export const getPreparationServerRejected = createAction(
  Types.GET_PREPARATION_SERVER_REJECTED
);

export const getSupportServerRequest = createAction(
  Types.GET_SUPPORT_SERVERS_REQUEST
);
export const getSupportServerFulfilled = createAction(
  Types.GET_SUPPORT_SERVERS_FULFILLED
);
export const getSupportServerRejected = createAction(
  Types.GET_SUPPORT_SERVERS_REJECTED
);

export const getAllServersRequest = createAction(Types.GET_ALL_SERVERS_REQUEST);
export const getAllServersFulfilled = createAction(
  Types.GET_ALL_SERVERS_FULFILLED
);
export const getAllServersRejected = createAction(
  Types.GET_ALL_SERVERS_REJECTED
);

export const getAllModelsRequest = createAction(Types.GET_ALL_MODELS_REQUEST);
export const getAllModelsFulfilled = createAction(
  Types.GET_ALL_MODELS_FULFILLED
);
export const getAllModelsRejected = createAction(Types.GET_ALL_MODELS_REJECTED);

export const getModelRequest = createAction(Types.GET_MODEL_REQUEST);
export const getModelFulfilled = createAction(Types.GET_MODEL_FULFILLED);
export const getModelRejected = createAction(Types.GET_MODEL_REJECTED);

export const registerModelRequest = createAction(Types.REGISTER_MODEL_REQUEST);
export const registerModelFulfilled = createAction(
  Types.REGISTER_MODEL_FULFILLED
);
export const registerModelRejected = createAction(
  Types.REGISTER_MODEL_REJECTED
);

export const editModelRequest = createAction(Types.EDIT_MODEL_REQUEST);
export const editModelFulfilled = createAction(Types.EDIT_MODEL_FULFILLED);
export const editModelRejected = createAction(Types.EDIT_MODEL_REJECTED);

export const removeModelRequest = createAction(Types.REMOVE_MODEL_REQUEST);
export const removeModelFulfilled = createAction(Types.REMOVE_MODEL_FULFILLED);
export const removeModelRejected = createAction(Types.REMOVE_MODEL_REJECTED);

export const getAllLogsRequest = createAction(Types.GET_ALL_LOGS_REQUEST);
export const getAllLogsFulfilled = createAction(Types.GET_ALL_LOGS_FULFILLED);
export const getAllLogsReject = createAction(Types.GET_ALL_LOGS_REJECT);

export const attachServerRequest = createAction(Types.ATTACH_SERVER_REQUEST);
export const attachServerFulfilled = createAction(
  Types.ATTACH_SERVER_FULFILLED
);
export const attachServerRejected = createAction(Types.ATTACH_SERVER_REJECTED);
export const detachServerRequest = createAction(Types.DETACH_SERVER_REQUEST);
export const detachServerFulfilled = createAction(
  Types.DETACH_SERVER_FULFILLED
);
export const detachServerRejected = createAction(Types.DETACH_SERVER_REJECTED);

export const getProviderResourcesRequest = createAction(
  Types.GET_PROVIDER_RESOURCES_REQUEST
);
export const getProviderResourcesFulfilled = createAction(
  Types.GET_PROVIDER_RESOURCES_FULFILLED
);
export const getProviderResourcesRejected = createAction(
  Types.GET_PROVIDER_RESOURCES_REJECTED
);

export const getAwsResourcesRequest = createAction(
  Types.GET_AWS_RESOURCES_REQUEST
);

export const getOciResourcesRequest = createAction(
  Types.GET_OCI_RESOURCES_REQUEST
);

export const getBootVolumesRequest = createAction(
  Types.GET_BOOT_VOLUMES_REQUEST
);
export const getBootVolumesFulFilled = createAction(
  Types.GET_BOOT_VOLUMES_FULFILLED
);
export const getBootVolumesRejected = createAction(
  Types.GET_BOOT_VOLUMES_REJECTED
);

export const getBootVolumeBackupsRequest = createAction(
  Types.GET_BOOT_VOLUME_BACKUPS_REQUEST
);
export const getBootVolumeBackupsFulFilled = createAction(
  Types.GET_BOOT_VOLUME_BACKUPS_FULFILLED
);
export const getBootVolumeBackupsRejected = createAction(
  Types.GET_BOOT_VOLUME_BACKUPS_REJECTED
);

export const getSecurityGroupsRequest = createAction(
  Types.GET_SECURITY_GROUPS_REQUEST
);
export const getSecurityGroupsFulFilled = createAction(
  Types.GET_SECURITY_GROUPS_FULFILLED
);
export const getSecurityGroupsRejected = createAction(
  Types.GET_SECURITY_GROUPS_REJECTED
);

export const getZonesRequest = createAction(Types.GET_ZONES_REQUEST);
export const getZonesFulFilled = createAction(Types.GET_ZONES_FULFILLED);
export const getZonesRejected = createAction(Types.GET_ZONES_REJECTED);

export const getSubnetsRequest = createAction(Types.GET_SUBNETS_REQUEST);
export const getSubnetsFulFilled = createAction(Types.GET_SUBNETS_FULFILLED);
export const getSubnetsRejected = createAction(Types.GET_SUBNETS_REJECTED);

export const getKeyPairsRequest = createAction(Types.GET_KEY_PAIRS_REQUEST);
export const getKeyPairsFulFilled = createAction(Types.GET_KEY_PAIRS_FULFILLED);
export const getKeyPairsRejected = createAction(Types.GET_KEY_PAIRS_REJECTED);

export const getImagesRequest = createAction(Types.GET_IMAGES_REQUEST);
export const getImagesFulFilled = createAction(Types.GET_IMAGES_FULFILLED);
export const getImagesRejected = createAction(Types.GET_IMAGES_REJECTED);

export const getListProviderResourcesRequest = createAction(
  Types.GET_LIST_PROVIDER_RESOURCES_REQUEST
);
export const getListProviderResourcesFulFilled = createAction(
  Types.GET_LIST_PROVIDER_RESOURCES_FULFILLED
);
export const getListProviderResourcesRejected = createAction(
  Types.GET_LIST_PROVIDER_RESOURCES_REJECTED
);

export const getFlavorsFulFilled = createAction(Types.GET_FLAVORS_FULFILLED);
export const getFlavorsRequest = createAction(Types.GET_FLAVORS_REQUEST);
export const getFlavorsRejected = createAction(Types.GET_FLAVORS_REJECTED);

export const stopTimeRequest = createAction(Types.STOP_TIME_REQUEST);
export const stopTimeFulfilled = createAction(Types.STOP_TIME_FULFILLED);
export const stopTimeRejected = createAction(Types.STOP_TIME_REJECTED);

export const cleanEnvironmentRequest = createAction(
  Types.CLEAN_ENVIRONMENT_REQUEST
);

export const connectAsRequest = createAction(Types.CONNECT_AS_REQUEST);
export const connectAsFulfilled = createAction(Types.CONNECT_AS_FULFILLED);
export const connectAsRejected = createAction(Types.CONNECT_AS_REJECTED);

export const getDashboardSessionsGraphRequest = createAction(
  Types.GET_DASHBOARD_SESSIONS_GRAPH_REQUEST
);
export const getDashboardEnvironmentCostGraphRequest = createAction(
  Types.GET_DASHBOARD_ENVIRONMENT_COST_GRAPH_REQUEST
);

export const getDashboardSessionsGraphFulfilled = createAction(
  Types.GET_DASHBOARD_SESSIONS_GRAPH_FULFILLED
);
export const getDashboardEnvironmentCostGraphFulfilled = createAction(
  Types.GET_DASHBOARD_ENVIRONMENT_COST_GRAPH_FULFILLED
);

export const getDashboardSessionsGraphRejected = createAction(
  Types.GET_DASHBOARD_SESSIONS_GRAPH_REJECTED
);
export const getDashboardEnvironmentCostGraphRejected = createAction(
  Types.GET_DASHBOARD_ENVIRONMENT_COST_GRAPH_REJECTED
);

export const setPeriodFilter = createAction(Types.SET_PERIOD_FILTER);
export const setPerformanceDateFilter = createAction(
  Types.SET_PERFORMANCE_DATE_FILTER
);
export const setEnvironmentCostPeriodFilter = createAction(
  Types.SET_ENVIRONMENT_COST_PERIOD_FILTER
);
export const setEnvironmentAvgMaxFilterCPU = createAction(
  Types.SET_ENVIRONMENT_AVG_MAX_FILTER_CPU
);

export const setEnvironmentAvgMaxFilterMemory = createAction(
  Types.SET_ENVIRONMENT_AVG_MAX_FILTER_MEMORY
);

export const setEnvironmentAvgMaxFilterOperationalTime = createAction(
  Types.SET_ENVIRONMENT_AVG_MAX_FILTER_OPERATIONAL_TIME
);

export const getFlavorsCostRequest = createAction(
  Types.GET_FLAVORS_COST_REQUEST
);
export const getFlavorsCostFulfilled = createAction(
  Types.GET_FLAVORS_COST_FULFILLED
);
export const getFlavorsCostRejected = createAction(
  Types.GET_FLAVORS_COST_REJECTED
);
export const setFlavorsCostPeriodFilter = createAction(
  Types.SET_FLAVORS_COST_PERIOD_FILTER
);

export const getAllApplicationsAutoskyRequest = createAction(
  Types.GET_ALL_APPLICATIONS_AUTOSKY_REQUEST
);
export const getAllApplicationsAutoskyFulfilled = createAction(
  Types.GET_ALL_APPLICATIONS_AUTOSKY_FULFILLED
);
export const getAllApplicationsAutoskyRejected = createAction(
  Types.GET_ALL_APPLICATIONS_AUTOSKY_REJECTED
);

export const getClientsApplicationsAutoskyRequest = createAction(
  Types.GET_CLIENTS_APPLICATIONS_AUTOSKY_REQUEST
);
export const getClientsApplicationsAutoskyFulfilled = createAction(
  Types.GET_CLIENTS_APPLICATIONS_AUTOSKY_FULFILLED
);
export const getClientsApplicationsAutoskyRejected = createAction(
  Types.GET_CLIENTS_APPLICATIONS_AUTOSKY_REJECTED
);

export const renameClientsApplicationsAutoskyRequest = createAction(
  Types.RENAME_CLIENTS_APPLICATIONS_AUTOSKY_REQUEST
);
export const renameClientsApplicationsAutoskyFulfilled = createAction(
  Types.RENAME_CLIENTS_APPLICATIONS_AUTOSKY_FULFILLED
);
export const renameClientsApplicationsAutoskyRejected = createAction(
  Types.RENAME_CLIENTS_APPLICATIONS_AUTOSKY_REJECTED
);

export const removeClientsApplicationsAutoskyRequest = createAction(
  Types.REMOVE_CLIENTS_APPLICATIONS_AUTOSKY_REQUEST
);
export const removeClientsApplicationsAutoskyFulfilled = createAction(
  Types.REMOVE_CLIENTS_APPLICATIONS_AUTOSKY_FULFILLED
);
export const removeClientsApplicationsAutoskyRejected = createAction(
  Types.REMOVE_CLIENTS_APPLICATIONS_AUTOSKY_REJECTED
);

export const changeStateClientsApplicationsAutoskyRequest = createAction(
  Types.CHANGE_STATE_CLIENTS_APPLICATIONS_AUTOSKY_REQUEST
);
export const changeStateClientsApplicationsAutoskyFulfilled = createAction(
  Types.CHANGE_STATE_CLIENTS_APPLICATIONS_AUTOSKY_FULFILLED
);
export const changeStateClientsApplicationsAutoskyRejected = createAction(
  Types.CHANGE_STATE_CLIENTS_APPLICATIONS_AUTOSKY_REJECTED
);

export const includeClientsApplicationsAutoskyRequest = createAction(
  Types.INCLUDE_CLIENTS_APPLICATIONS_AUTOSKY_REQUEST
);
export const includeClientsApplicationsAutoskyFulfilled = createAction(
  Types.INCLUDE_CLIENTS_APPLICATIONS_AUTOSKY_FULFILLED
);
export const includeClientsApplicationsAutoskyRejected = createAction(
  Types.INCLUDE_CLIENTS_APPLICATIONS_AUTOSKY_REJECTED
);

export const getClientsToIncludeApplicationsAutoskyRequest = createAction(
  Types.GET_CLIENTS_TO_INCLUDE_APPLICATIONS_AUTOSKY_REQUEST
);
export const getClientsToIncludeApplicationsAutoskyFulfilled = createAction(
  Types.GET_CLIENTS_TO_INCLUDE_APPLICATIONS_AUTOSKY_FULFILLED
);
export const getClientsToIncludeApplicationsAutoskyRejected = createAction(
  Types.GET_CLIENTS_TO_INCLUDE_APPLICATIONS_AUTOSKY_REJECTED
);

export const getAllApplicationsPlatformRequest = createAction(
  Types.GET_ALL_APPLICATIONS_PLATFORM_REQUEST
);
export const getAllApplicationsPlatformFulfilled = createAction(
  Types.GET_ALL_APPLICATIONS_PLATFORM_FULFILLED
);
export const getAllApplicationsPlatformRejected = createAction(
  Types.GET_ALL_APPLICATIONS_PLATFORM_REJECTED
);

export const getClientsApplicationsPlatformRequest = createAction(
  Types.GET_CLIENTS_APPLICATIONS_PLATFORM_REQUEST
);
export const getClientsApplicationsPlatformFulfilled = createAction(
  Types.GET_CLIENTS_APPLICATIONS_PLATFORM_FULFILLED
);
export const getClientsApplicationsPlatformRejected = createAction(
  Types.GET_CLIENTS_APPLICATIONS_PLATFORM_REJECTED
);

export const removeClientsApplicationsPlatformRequest = createAction(
  Types.REMOVE_CLIENTS_APPLICATIONS_PLATFORM_REQUEST
);
export const removeClientsApplicationsPlatformFulfilled = createAction(
  Types.REMOVE_CLIENTS_APPLICATIONS_PLATFORM_FULFILLED
);
export const removeClientsApplicationsPlatformRejected = createAction(
  Types.REMOVE_CLIENTS_APPLICATIONS_PLATFORM_REJECTED
);

export const migrateEnvironmentRequest = createAction(
  Types.MIGRATE_ENVIRONMENT_REQUEST
);
export const migrateEnvironmentFulfilled = createAction(
  Types.MIGRATE_ENVIRONMENT_FULFILLED
);
export const migrateEnvironmentRejected = createAction(
  Types.MIGRATE_ENVIRONMENT_REJECTED
);
export const setMigrateErrors = createAction(Types.SET_MIGRATE_ERRORS);

export const getEnvironmentPerformanceCPURequest = createAction(
  Types.GET_ENVIRONMENT_PERFORMANCE_CPU_REQUEST
);
export const getEnvironmentPerformanceCPUFulfilled = createAction(
  Types.GET_ENVIRONMENT_PERFORMANCE_CPU_FULFILLED
);
export const getEnvironmentPerformanceCPURejected = createAction(
  Types.GET_ENVIRONMENT_PERFORMANCE_CPU_REJECTED
);

export const getEnvironmentPerformanceMemoryRequest = createAction(
  Types.GET_ENVIRONMENT_PERFORMANCE_MEMORY_REQUEST
);
export const getEnvironmentPerformanceMemoryFulfilled = createAction(
  Types.GET_ENVIRONMENT_PERFORMANCE_MEMORY_FULFILLED
);
export const getEnvironmentPerformanceMemoryRejected = createAction(
  Types.GET_ENVIRONMENT_PERFORMANCE_MEMORY_REJECTED
);

export const getEnvironmentMonitoringRequest = createAction(
  Types.GET_ENVIRONMENT_MONITORING_REQUEST
);
export const getEnvironmentMonitoringFulfilled = createAction(
  Types.GET_ENVIRONMENT_MONITORING_FULFILLED
);
export const getEnvironmentMonitoringRejected = createAction(
  Types.GET_ENVIRONMENT_MONITORING_REJECTED
);

export const editEnvironmentMonitoringRequest = createAction(
  Types.EDIT_ENVIRONMENT_MONITORING_REQUEST
);
export const editEnvironmentMonitoringFulfilled = createAction(
  Types.EDIT_ENVIRONMENT_MONITORING_FULFILLED
);
export const editEnvironmentMonitoringRejected = createAction(
  Types.EDIT_ENVIRONMENT_MONITORING_REJECTED
);

export const getMonitoringHistoryRequest = createAction(
  Types.GET_MONITORING_HISTORY_REQUEST
);
export const getMonitoringHistoryFulfilled = createAction(
  Types.GET_MONITORING_HISTORY_FULFILLED
);
export const getMonitoringHistoryRejected = createAction(
  Types.GET_MONITORING_HISTORY_REJECTED
);

export const getEnvironmentPerformanceOperationalTimeRequest = createAction(
  Types.GET_ENVIRONMENT_PERFORMANCE_OPERATIONAL_TIME_REQUEST
);
export const getEnvironmentPerformanceOperationalTimeFulfilled = createAction(
  Types.GET_ENVIRONMENT_PERFORMANCE_OPERATIONAL_TIME_FULFILLED
);
export const getEnvironmentPerformanceOperationalTimeRejected = createAction(
  Types.GET_ENVIRONMENT_PERFORMANCE_OPERATIONAL_TIME_REJECTED
);

export const getPublicationScheduleRequest = createAction(
  Types.GET_PUBLICATION_SCHEDULE_REQUEST
);
export const getPublicationScheduleFulfilled = createAction(
  Types.GET_PUBLICATION_SCHEDULE_FULFILLED
);
export const getPublicationScheduleRejected = createAction(
  Types.GET_PUBLICATION_SCHEDULE_REJECTED
);

export const setPublicationScheduleRequest = createAction(
  Types.SET_PUBLICATION_SCHEDULE_REQUEST
);
export const setPublicationScheduleFulfilled = createAction(
  Types.SET_PUBLICATION_SCHEDULE_FULFILLED
);
export const setPublicationScheduleRejected = createAction(
  Types.SET_PUBLICATION_SCHEDULE_REJECTED
);

export const cancelPublicationScheduleRequest = createAction(
  Types.CANCEL_PUBLICATION_SCHEDULE_REQUEST
);
export const cancelPublicationScheduleFulfilled = createAction(
  Types.CANCEL_PUBLICATION_SCHEDULE_FULFILLED
);
export const cancelPublicationScheduleRejected = createAction(
  Types.CANCEL_PUBLICATION_SCHEDULE_REJECTED
);

export const getBulkClientsRequest = createAction(
  Types.GET_BULK_CLIENTS_REQUEST
);
export const getBulkClientsFulfilled = createAction(
  Types.GET_BULK_CLIENTS_FULFILLED
);
export const getBulkClientsRejected = createAction(
  Types.GET_BULK_CLIENTS_REJECTED
);
export const editBulkClientsRequest = createAction(
  Types.EDIT_BULK_CLIENTS_REQUEST
);
export const editBulkClientsFulfilled = createAction(
  Types.EDIT_BULK_CLIENTS_FULFILLED
);
export const editBulkClientsRejected = createAction(
  Types.EDIT_BULK_CLIENTS_REJECTED
);

export const setSelectedEnvironment = createAction(
  Types.SET_SELECTED_ENVIRONMENT
);

export const setProductionEnvironmentRequest = createAction(
  Types.SET_PRODUCTION_ENVIRONMENT_REQUEST
);

export const acceptStatusPendingRequest = createAction(
  Types.ACCEPT_STATUS_PENDING_REQUEST
);
export const acceptStatusPendingFulfilled = createAction(
  Types.ACCEPT_STATUS_PENDING_FULFILLED
);
export const acceptStatusPendingRejected = createAction(
  Types.ACCEPT_STATUS_PENDING_REJECTED
);

export const getBehaviorReportFulfilled = createAction(
  Types.GET_BEHAVIOR_REPORT_FULFILLED
);
export const getBehaviorReportRejected = createAction(
  Types.GET_BEHAVIOR_REPORT_REJECTED
);
export const getBehaviorReportRequest = createAction(
  Types.GET_BEHAVIOR_REPORT_REQUEST
);

export const getDNSReportFulfilled = createAction(
  Types.GET_DNS_REPORT_FULFILLED
);
export const getDNSReportRejected = createAction(Types.GET_DNS_REPORT_REJECTED);
export const getDNSReportRequest = createAction(Types.GET_DNS_REPORT_REQUEST);

export const getMaintenanceReportFulfilled = createAction(
  Types.GET_MAINTENANCE_REPORT_FULFILLED
);
export const getMaintenanceReportRejected = createAction(
  Types.GET_MAINTENANCE_REPORT_REJECTED
);
export const getMaintenanceReportRequest = createAction(
  Types.GET_MAINTENANCE_REPORT_REQUEST
);

export const getProductReportFulfilled = createAction(
  Types.GET_PRODUCT_REPORT_FULFILLED
);
export const getProductReportRejected = createAction(
  Types.GET_PRODUCT_REPORT_REJECTED
);
export const getProductReportRequest = createAction(
  Types.GET_PRODUCT_REPORT_REQUEST
);

export const getProductTypeReportRequest = createAction(
  Types.GET_PRODUCT_TYPE_REPORT_REQUEST
);
export const getProductTypeReportFulfilled = createAction(
  Types.GET_PRODUCT_TYPE_REPORT_FULFILLED
);
export const getProductTypeReportRejected = createAction(
  Types.GET_PRODUCT_TYPE_REPORT_REJECTED
);

export const getProviderReportFulfilled = createAction(
  Types.GET_PROVIDER_REPORT_FULFILLED
);
export const getProviderReportRejected = createAction(
  Types.GET_PROVIDER_REPORT_REJECTED
);
export const getProviderReportRequest = createAction(
  Types.GET_PROVIDER_REPORT_REQUEST
);

export const getRegionReportFulfilled = createAction(
  Types.GET_REGION_REPORT_FULFILLED
);
export const getRegionReportRejected = createAction(
  Types.GET_REGION_REPORT_REJECTED
);
export const getRegionReportRequest = createAction(
  Types.GET_REGION_REPORT_REQUEST
);

export const getStatusReportFulfilled = createAction(
  Types.GET_STATUS_REPORT_FULFILLED
);
export const getStatusReportRejected = createAction(
  Types.GET_STATUS_REPORT_REJECTED
);
export const getStatusReportRequest = createAction(
  Types.GET_STATUS_REPORT_REQUEST
);

export const getVirtualizerReportFulfilled = createAction(
  Types.GET_VIRTUALIZER_REPORT_FULFILLED
);
export const getVirtualizerReportRejected = createAction(
  Types.GET_VIRTUALIZER_REPORT_REJECTED
);
export const getVirtualizerReportRequest = createAction(
  Types.GET_VIRTUALIZER_REPORT_REQUEST
);

export const getZeroTrustReportFulfilled = createAction(
  Types.GET_ZERO_TRUST_REPORT_FULFILLED
);
export const getZeroTrustReportRejected = createAction(
  Types.GET_ZERO_TRUST_REPORT_REJECTED
);
export const getZeroTrustReportRequest = createAction(
  Types.GET_ZERO_TRUST_REPORT_REQUEST
);

export const getTimezonesRequest = createAction(Types.GET_TIMEZONES_REQUEST);
export const getTimezonesFulfilled = createAction(
  Types.GET_TIMEZONES_FULFILLED
);
export const getTimezonesRejected = createAction(Types.GET_TIMEZONES_REJECTED);
export const setSelectedTimezone = createAction(Types.SET_SELECTED_TIMEZONE);

export const extendCompletionDateRequest = createAction(
  Types.EXTEND_COMPLETION_DATE_REQUEST
);
export const extendCompletionDateFulfilled = createAction(
  Types.EXTEND_COMPLETION_DATE_FULFILLED
);
export const extendCompletionDateRejected = createAction(
  Types.EXTEND_COMPLETION_DATE_REJECTED
);

export const exportEnvironmentSummaryRequest = createAction(
  Types.EXPORT_ENVIRONMENT_SUMMARY_REQUEST
);
export const exportEnvironmentSummaryFulfilled = createAction(
  Types.EXPORT_ENVIRONMENT_SUMMARY_FULFILLED
);
export const exportEnvironmentSummaryRejected = createAction(
  Types.EXPORT_ENVIRONMENT_SUMMARY_REJECTED
);

export const validateZeroTrustRequest = createAction(
  Types.VALIDATE_ZERO_TRUST_REQUEST
);
export const validateZeroTrustFulfilled = createAction(
  Types.VALIDATE_ZERO_TRUST_FULFILLED
);
export const validateZeroTrustRejected = createAction(
  Types.VALIDATE_ZERO_TRUST_REJECTED
);

export const publishImageRequest = createAction(Types.PUBLISH_IMAGE_REQUEST);
export const publishImageFulfilled = createAction(
  Types.PUBLISH_IMAGE_FULFILLED
);
export const publishImageRejected = createAction(Types.PUBLISH_IMAGE_REJECTED);

export const getPublishHistoryRequest = createAction(
  Types.GET_PUBLISH_HISTORY_REQUEST
);
export const getPublishHistoryFulfilled = createAction(
  Types.GET_PUBLISH_HISTORY_FULFILLED
);
export const getPublishHistoryRejected = createAction(
  Types.GET_PUBLISH_HISTORY_REJECTED
);

export const exportHistoryMonitoringCSVRequest = createAction(
  Types.EXPORT_HISTORY_MONITORING_CSV_REQUEST
);
export const exportHistoryMonitoringCSVFulfilled = createAction(
  Types.EXPORT_HISTORY_MONITORING_CSV_FULFILLED
);
export const exportHistoryMonitoringCSVRejected = createAction(
  Types.EXPORT_HISTORY_MONITORING_CSV_REJECTED
);
export const blockServerActionsRequest = createAction(
  Types.BLOCK_SERVER_ACTIONS_REQUEST
);
export const blockServerActionsFulfilled = createAction(
  Types.BLOCK_SERVER_ACTIONS_FULFILLED
);
export const blockServerActionsRejected = createAction(
  Types.BLOCK_SERVER_ACTIONS_REJECTED
);

export const unblockServerActionsRequest = createAction(
  Types.UNBLOCK_SERVER_ACTIONS_REQUEST
);
export const unblockServerActionsFulfilled = createAction(
  Types.UNBLOCK_SERVER_ACTIONS_FULFILLED
);
export const unblockServerActionsRejected = createAction(
  Types.UNBLOCK_SERVER_ACTIONS_REJECTED
);
export const getEnvironmentSessionsRequest = createAction(
  Types.GET_ENVIRONMENT_SESSIONS_REQUEST
);
export const getEnvironmentSessionsFulfilled = createAction(
  Types.GET_ENVIRONMENT_SESSIONS_FULFILLED
);
export const getEnvironmentSessionsRejected = createAction(
  Types.GET_ENVIRONMENT_SESSIONS_REJECTED
);

export const getLicenseGroupsRequest = createAction(
  Types.GET_LICENSE_GROUPS_REQUEST
);
export const getLicenseGroupsFulfilled = createAction(
  Types.GET_LICENSE_GROUPS_FULFILLED
);
export const getLicenseGroupsRejected = createAction(
  Types.GET_LICENSE_GROUPS_REJECTED
);

export const createLicenseGroupRequest = createAction(
  Types.CREATE_LICENSE_GROUP_REQUEST
);
export const createLicenseGroupFulfilled = createAction(
  Types.CREATE_LICENSE_GROUP_FULFILLED
);
export const createLicenseGroupRejected = createAction(
  Types.CREATE_LICENSE_GROUP_REJECTED
);

export const getLicenseGroupDetailsRequest = createAction(
  Types.GET_LICENSE_GROUP_DETAILS_REQUEST
);
export const getLicenseGroupDetailsFulfilled = createAction(
  Types.GET_LICENSE_GROUP_DETAILS_FULFILLED
);
export const getLicenseGroupDetailsRejected = createAction(
  Types.GET_LICENSE_GROUP_DETAILS_REJECTED
);

export const editLicenseGroupRequest = createAction(
  Types.EDIT_LICENSE_GROUP_REQUEST
);
export const editLicenseGroupFulfilled = createAction(
  Types.EDIT_LICENSE_GROUP_FULFILLED
);
export const editLicenseGroupRejected = createAction(
  Types.EDIT_LICENSE_GROUP_REJECTED
);

export const deleteLicenseGroupRequest = createAction(
  Types.DELETE_LICENSE_GROUP_REQUEST
);
export const deleteLicenseGroupFulfilled = createAction(
  Types.DELETE_LICENSE_GROUP_FULFILLED
);
export const deleteLicenseGroupRejected = createAction(
  Types.DELETE_LICENSE_GROUP_REJECTED
);

export const addClientsToLicenseGroupRequest = createAction(
  Types.ADD_CLIENTS_TO_LICENSE_GROUP_REQUEST
);
export const addClientsToLicenseGroupFulfilled = createAction(
  Types.ADD_CLIENTS_TO_LICENSE_GROUP_FULFILLED
);
export const addClientsToLicenseGroupRejected = createAction(
  Types.ADD_CLIENTS_TO_LICENSE_GROUP_REJECTED
);

export const fullUpdateLicenseGroupClientsRequest = createAction(
  Types.FULL_UPDATE_LICENSE_GROUP_CLIENTS_REQUEST
);
export const fullUpdateLicenseGroupClientsFulfilled = createAction(
  Types.FULL_UPDATE_LICENSE_GROUP_CLIENTS_FULFILLED
);
export const fullUpdateLicenseGroupClientsRejected = createAction(
  Types.FULL_UPDATE_LICENSE_GROUP_CLIENTS_REJECTED
);

export const getConnectionTypeEnvironmentReportRequest = createAction(
  Types.GET_CONNECTION_TYPE_ENVIRONMENT_REPORT_REQUEST
);
export const getConnectionTypeEnvironmentReportFulfilled = createAction(
  Types.GET_CONNECTION_TYPE_ENVIRONMENT_REPORT_FULFILLED
);
export const getConnectionTypeEnvironmentReportRejected = createAction(
  Types.GET_CONNECTION_TYPE_ENVIRONMENT_REPORT_REJECTED
);

export const getEnvironmentAdvisorsRequest = createAction(
  Types.GET_ENVIRONMENT_ADVISORS_REQUEST
);
export const getEnvironmentAdvisorsFulfilled = createAction(
  Types.GET_ENVIRONMENT_ADVISORS_FULFILLED
);
export const getEnvironmentAdvisorsRejected = createAction(
  Types.GET_ENVIRONMENT_ADVISORS_REJECTED
);

export const getAdminPinRequest = createAction(Types.GET_ADMIN_PIN_REQUEST);
export const getAdminPinFulfilled = createAction(Types.GET_ADMIN_PIN_FULFILLED);
export const getAdminPinRejected = createAction(Types.GET_ADMIN_PIN_REJECTED);

export const resetAdminPinRequest = createAction(Types.RESET_ADMIN_PIN_REQUEST);
export const resetAdminPinFulfilled = createAction(
  Types.RESET_ADMIN_PIN_FULFILLED
);
export const resetAdminPinRejected = createAction(
  Types.RESET_ADMIN_PIN_REJECTED
);

export const enableServerMonitoringManagementRequest = createAction(
  Types.ENABLE_SERVER_MONITORING_MANAGEMENT_REQUEST
);
export const enableServerMonitoringManagementFulfilled = createAction(
  Types.ENABLE_SERVER_MONITORING_MANAGEMENT_FULFILLED
);
export const enableServerMonitoringManagementRejected = createAction(
  Types.ENABLE_SERVER_MONITORING_MANAGEMENT_REJECTED
);
export const disableServerMonitoringManagementRequest = createAction(
  Types.DISABLE_SERVER_MONITORING_MANAGEMENT_REQUEST
);
export const disableServerMonitoringManagementFulfilled = createAction(
  Types.DISABLE_SERVER_MONITORING_MANAGEMENT_FULFILLED
);
export const disableServerMonitoringManagementRejected = createAction(
  Types.DISABLE_SERVER_MONITORING_MANAGEMENT_REJECTED
);

export const getAllServersMonitoringStatusRequest = createAction(
  Types.GET_ALL_SERVERS_MONITORING_STATUS_REQUEST
);

export const getServerMonitoringStatusRequest = createAction(
  Types.GET_SERVER_MONITORING_STATUS_REQUEST
);
export const getServerMonitoringStatusFulfilled = createAction(
  Types.GET_SERVER_MONITORING_STATUS_FULFILLED
);
export const getServerMonitoringStatusRejected = createAction(
  Types.GET_SERVER_MONITORING_STATUS_REJECTED
);
